/* eslint-disable react/no-danger */
import React from "react";
import PropTypes from "prop-types";

import Env from "app/core/environment";
import Resource from "app/core/resource";

import ProductTypeEnum from "app/core/utilites/enum/productType";

class InfoBlock extends React.Component {
    constructor(props) {
        super(props);
        /**
         * @property env
         * @type {Object}
         */
        this.env = Env.getInstance();

        /**
         * @property stringsResource
         * @type {Object}
         */
        this.stringsResource = Resource.getStrings(Env.getInstance().getLanguage());

        /**
         * @property linksResource
         * @type {Object}
         */
        this.linksResource = Resource.links;

        /**
         * @property productTypeEnum
         * @type {Enum}
         */
        this.productTypeEnum = ProductTypeEnum.getInstance();
    }

    /**
     * @method _hasBrands
     * @return {boolean}
     * @private
     */
    _hasType() {
        return Boolean(this.props.productType);
    }

    /**
     * @method _hasBrands
     * @return {boolean}
     * @private
     */
    _hasBrands() {
        return Boolean(this.props.brands.length);
    }

    /**
     * @method _hasGeneric
     * @return {boolean}
     * @private
     */
    _hasGeneric() {
        return Boolean(this.props.generic);
    }

    /**
     * @method _isGeneric
     * @return {boolean}
     * @private
     */
    _isGeneric() {
        return this.productTypeEnum.isGeneric(this.props.productType);
    }

    /**
     * @method _isDisplayGeneric
     * @return {boolean}
     * @private
     */
    _isDisplayGeneric() {
        return this._hasGeneric() || this._isGeneric();
    }

    /**
     * @method _isOriginalForGeneric
     * @return {boolean}
     * @private
     */
    _isOriginalForGeneric() {
        return Boolean(this.props.original);
    }

    /**
     * @method _getBrands
     * @return {Array}
     * @private
     */
    _getBrands() {
        return this.props.brands.map((item) => (
            <a
                key={item.id}
                href={item.url}
                className="text-decoration-none"
            >
                {item.name}
            </a>
        ));
    }

    /**
     * @private
     * @method _buildGenericText
     * @returns {string}
     */
    _buildGenericText() {
        let result = "";

        if (this._hasType() && this._isGeneric()) {
            result = <span>{this.props.name}</span>;
        }

        if (this._hasType() && !this._isGeneric()) {
            result = (
                <a href={this.props.generic?.url} className="text-decoration-none">
                    {this.props.generic?.name}
                </a>
            );
        }

        return result;
    }

    /**
     * @public
     * @method render
     * @returns {React.ReactElement}
     */
    render() {
        return (
            <section className="info-block">
                {(!this._isGeneric() || this._isOriginalForGeneric()) && (
                <div className="info-block__status">

                    {!this._isGeneric() && (
                        <>
                            <img src={this.linksResource.icons.starCircle} alt="status" className="mr-10" />
                            <span>{this.stringsResource.originalProduct}: {this.props.name}</span>
                        </>
                    )}

                    {this._isOriginalForGeneric() && (
                        <>
                            <img src={this.linksResource.icons.starCircle} alt="status" className="mr-10" />
                            <span className="mr-6">{this.stringsResource.originalProduct}:</span>
                            <a href={this.props.original?.url} className="text-decoration-none">
                                {this.props.original?.name}
                            </a>
                        </>
                    )}
                </div>
                )}

                {this._isDisplayGeneric() && (
                <div className="info-block__generic">
                    <img src={this.linksResource.icons.generic} alt="generic" className="mr-10" />
                    <div>
                        <span className="mr-6">{this.stringsResource.generic}:</span>
                        {this._buildGenericText()}
                    </div>
                </div>
                )}

                {this._hasBrands() && (
                <div className="info-block__brands">
                    <img src={this.linksResource.icons.brand} alt="brands" className="mr-10" />
                    <div>
                        <span className="mr-6">{this.stringsResource.brands}:</span>
                        {this._getBrands()}
                    </div>
                </div>
                )}
            </section>
        );
    }
}

InfoBlock.propTypes = {
    original: PropTypes.instanceOf(Object),
    generic: PropTypes.instanceOf(Object),
    brands: PropTypes.instanceOf(Array),
    productType: PropTypes.string,
    name: PropTypes.string
};

InfoBlock.defaultProps = {
    original: null,
    generic: null,
    brands: [],
    productType: "",
    name: ""
};

export default InfoBlock;
